/**
 * Single source of truth for social brand identity.
 *
 * `social_name` from the CMS `footer_social` table is interpolated straight into
 * the Font Awesome class AND the anchor `title`. That double duty is why the X
 * rebrand cannot be done from the admin panel: Font Awesome 4.7.0 ships no X
 * glyph (`fa-x-twitter` first appeared in FA 6.4.2), so `fa fa-x` renders an
 * empty box. Anything listed here is drawn as inline SVG instead of an icon
 * font, and carries its own accessible label.
 */

export type BrandKey = 'x';

/** CMS `social_name` values that should render as the X mark. */
const X_ALIASES = ['x', 'twitter', 'x-twitter'];

/** Brands drawn as inline SVG rather than via a Font Awesome class. */
export function brandKeyFor(name: string): BrandKey | null {
  const key = (name || '').trim().toLowerCase();
  return X_ALIASES.indexOf(key) > -1 ? 'x' : null;
}

/**
 * Accessible label for a social link. Deliberately independent of the raw CMS
 * value so the X link reads "X" while the row still says "twitter".
 */
export function socialLabelFor(name: string): string {
  if (brandKeyFor(name) === 'x') {
    return 'X';
  }
  return name || '';
}
